export default window.localStorage;
